export default window.localStorage;
